import React, { useContext, useEffect, useState } from "react";
import { Box, FormControl, Input, Select, Option, Autocomplete, Button, Typography, Divider } from "@mui/joy"
import { formatPhoneNumber } from "../utils/FormatNoteNameAndText";
import { axiosInstance } from "../services/Axios";
import FloatingLabelInput from "../components/joy/FloatingInput";
import { practiceTypes, specialties } from "./SignupView";
import { useNavigate, useSearchParams } from "react-router-dom";
import { AlertContext } from "../context/AlertFlag";
import { handleErrorSentry } from "../utils/constants/Error";

function OnboardingPage() {
    const [params] = useSearchParams();
    const [ fullName, setFullName ] = useState(null);
    const { addAlert } = useContext(AlertContext);
    const navigate = useNavigate();

    // For now, only handle Google as SSO provider
    const createUserWithSSO = async (formUser) => {
        const email = params.get("email");
        const full_name = params.get("full_name");
        try {
            const newUser = {
                full_name: full_name,
                email: email,
                password: "not_in_use_due_to_sso",
                ...formUser,
                force_update_password: false,
                sso: "google",
            };

            await axiosInstance.post('/api/user', newUser, {
                headers: { "Content-Type": "application/json" },
            })

            addAlert(
                "Success! You will be redirected to the login page in 5 seconds!",
                "success"
            );
            setTimeout(() => {
                navigate("/login");
            }, 5000);
            
        } catch(error) {
            handleErrorSentry(error, "tryCatch");
        }
    };

    useEffect(() => {
        const full_name = params.get("full_name");
        setFullName(full_name);
    }, [])

    return <Box
        sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        overflowX: "hidden",
    }}>
        <Box
        sx={(theme) => ({
            margin: "25px",
            borderRadius: "30px",
            display: "flex",
            flexDirection: "column",
            boxShadow: theme.shadow.md,
            backgroundColor: "rgb(255, 255, 255, 50%)",
            width: { sm: '100%', md: '50%'},
            paddingBottom: "30px",
        })}
        >
            <Box
            sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                my: "2rem",
            }}
            >
                <img src="/assets/logo.png" alt="Logo" style={{ maxWidth: "80%" }} />
            </Box>
            <Divider sx={{ mb: 4 }}/>
            <form style={{ width: "100%", justifyItems: "center" }} onSubmit={async (event) => {
                event.preventDefault();
                const formData = new FormData(event.currentTarget);
                const formFields = Object.fromEntries(formData.entries());
                await createUserWithSSO(formFields);
            }}>
                <FormControl sx={{ width: "80%", gap: 2}}>
                    <Typography level="title-lg"> Hi {fullName}!</Typography>
                    <Typography level="body-md"> We just need a couple more details before we can setup your profile!</Typography>
                    <FloatingLabelInput label="Phone Number" name="phone_number" onChange={(event) => {
                        event.target.value = formatPhoneNumber(event.target.value);
                    }} required/>
                    <FloatingLabelInput label="Organization Name" name="job_title" required/>
                    <Autocomplete 
                        name="practice" 
                        placeholder="Select Practice Type"
                        forcePopupIcon={false}
                        options={practiceTypes}
                        disableClearable
                        sx={{
                            fontFamily: "Inter, sans-serif", // Apply to the Select text
                        }}
                        required
                    />
                    <Autocomplete 
                        name="specialty" 
                        placeholder="Select Specialty"
                        forcePopupIcon={false}
                        options={specialties}
                        disableClearable
                        sx={{
                            fontFamily: "Inter, sans-serif", // Apply to the Select text
                        }}
                        required
                    />
                    <Select placeholder="Select Region" name="emr_ehr_provider" required>
                        <Option value="canada">Canada</Option>
                        <Option value="usa">United States of America</Option>
                        <Option value="other">Other</Option>
                    </Select>
                    <Button type="submit">
                        Create profile
                    </Button>
                </FormControl>
            </form>
        </Box>
    </Box>
}

export default OnboardingPage